package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Expense_entry(
  public val id: String,
  public val item_id: String,
  public val label: String,
  public val amount: Long,
  public val date: String?,
  public val note: String?,
  public val tx_id: String?,
  public val order_index: Long,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
